import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const AccountDeletionPolicy = () => {
  return (
    <div className="container px-4 pt-5 mt-5">
      <h2>Account Deletion Policy</h2>

      <p>
        At Rush Hub & Rush Valet , we currently do not support account deletion
        through the app or website. If you have any questions or need assistance
        regarding your account, please reach out to our support team.
      </p>
      <div className="mt-6 p-4 bg-blue-50 border-l-4 border-blue-500">
        <p className="text-gray-800 font-medium">
          📩 <strong>Email:</strong>{" "}
          <a
            href="mailto:support@gorush.co"
            className="text-blue-500 hover:underline"
          >
            support@gorush.co
          </a>
        </p>
      </div>
    </div>
  );
};

export default AccountDeletionPolicy;
